import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useContactForm } from "@/contexts/ContactFormContext";
import { useTranslation } from "@/i18n/LanguageContext";

const StickyMobileCTA = () => {
  const [visible, setVisible] = useState(false);
  const { openForm } = useContactForm();
  const { t } = useTranslation();

  useEffect(() => {
    const onScroll = () => {
      const heroEl = document.getElementById("hero-section");
      const ctaEl = document.getElementById("cta");
      if (!heroEl) return;
      const heroBottom = heroEl.getBoundingClientRect().bottom;
      const ctaTop = ctaEl?.getBoundingClientRect().top ?? Infinity;
      setVisible(heroBottom < 0 && ctaTop > window.innerHeight);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div className="fixed bottom-0 left-0 right-0 z-50 md:hidden" initial={{ y: 80, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 80, opacity: 0 }} transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}>
          <div className="px-4 pt-3 pb-[calc(0.75rem+env(safe-area-inset-bottom,0px))]" style={{ background: "linear-gradient(to top, hsl(240 10% 4% / 0.98) 60%, transparent)", backdropFilter: "blur(12px)" }}>
            <button onClick={openForm} className="btn-shimmer flex items-center justify-center w-full py-3.5 rounded-full text-primary-foreground font-display font-bold text-sm tracking-wide active:scale-[0.97]" style={{ transition: "transform 0.2s", background: "linear-gradient(135deg, hsl(191 100% 50%), hsl(191 100% 42%))", boxShadow: "0 0 20px hsl(191 100% 50% / 0.2)" }}>
              {t("mobileCta.text")}
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyMobileCTA;
